module.exports = __webpack_public_path__ + "static/media/6.74cd90e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/slides/6.png
// module id = 255
// module chunks = 0